import { Certificate } from "@/interfaces/Certificate";

export const certificates: Certificate[] = [
  {
    "number": "01/AEDU/MA/IX/2023",
    "name": "Octalianny Halim",
    "scheme": "Mobile Application Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Mobile Application Developer"
  },
  {
    "number": "02/AEDU/FSW/X/2023",
    "name": "Octalianny Halim",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "03/AEDU/FSW/IX/2023",
    "name": "Aditia Dwi Putra",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "04/AEDU/FSW/IX/2023",
    "name": "Faisal Aris",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "05/AEDU/VG/IX/2023",
    "name": "Clara Zefanya Putri Junaidi",
    "scheme": "Video Games Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Games Developer"
  },
  {
    "number": "06/AEDU/VG/X/2023",
    "name": "Yohanes Sujana WIjaya",
    "scheme": "Video Games Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Games Developer"
  },
  {
    "number": "07/AEDU/VG/IX/2023",
    "name": "Stanley Pratama Teguh",
    "scheme": "Video Games Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Games Developer"
  },
  {
    "number": "08/AEDU/VG/IX/2023",
    "name": "Dion Ferdinand",
    "scheme": "Video Games Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Games Developer"
  },
  {
    "number": "09/AEDU/FSW/IX/2023",
    "name": "Dwi Febriyanto",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "10/AEDU/FSW/IX/2023",
    "name": "Yosafat Solaiman",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "11/AEDU/FSW/X/2023",
    "name": "Jeannes Bryan",
    "scheme": "Full Stack Website",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Website"
  },
  {
    "number": "12/AEDU/FEW/I/2024",
    "name": "Louise Tamariska Utami",
    "scheme": "Front-end Website",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Front-end Website"
  },
  {
    "number": "13/AEDU/VG/II/2024",
    "name": "Febryanni Halim",
    "scheme": "Video Games Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Games Developer"
  },
  {
    "number": "14/AEDU/BD/2017",
    "name": "Giga Dharmawan",
    "scheme": "Business Development",
    "date": "2017",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "15/AEDU/FSD/2017",
    "name": "Tie Tientono",
    "scheme": "Full Stack Developer",
    "date": "2017",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "16/AEDU/FSD/2017",
    "name": "Ryan Elian",
    "scheme": "Full Stack Developer",
    "date": "2017",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "17/AEDU/FSD/2018",
    "name": "Felix Adrianto",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "18/AEDU/FSD/2018",
    "name": "Romy Hermawan",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "19/AEDU/FSD/2018",
    "name": "Steven Charles",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "20/AEDU/BA/2018",
    "name": "Dewi Nursalim",
    "scheme": "Business Analyst",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "21/AEDU/BA/2018",
    "name": "George",
    "scheme": "Business Analyst",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "22/AEDU/BA/2018",
    "name": "Charlie Pranata",
    "scheme": "Business Analyst",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "23/AEDU/FSD/2018",
    "name": "Anselmus Suryo",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "24/AEDU/FSD/2018",
    "name": "Marvin Sutanto",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "25/AEDU/FSD/2018",
    "name": "Axel Novandy Pradhana",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "26/AEDU/FSD/2018",
    "name": "Daniel",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "27/AEDU/FSD/2018",
    "name": "Vincentius Nicky Wijaya",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "28/AEDU/FSD/2018",
    "name": "Adrian Christanto",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "29/AEDU/FSD/2018",
    "name": "Liem Hindra",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "30/AEDU/FSD/2018",
    "name": "Kevin Andrivia",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "31/AEDU/FSD/2018",
    "name": "Raditya Juanda",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "32/AEDU/FSD/2018",
    "name": "Crist Yonathan Effendi",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "33/AEDU/FSD/2018",
    "name": "Mikhael  Pramodana Agus",
    "scheme": "Full Stack Developer",
    "date": "2018",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "34/AEDU/FSD/2019",
    "name": "Henry Prasetio",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "35/AEDU/FSD/2019",
    "name": "Riandy Naga Setiawan",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "36/AEDU/FSD/2019",
    "name": "Hans Advent Maruli TamBusiness Analyst",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "37/AEDU/FSD/2019",
    "name": "Michael Satya Putra",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "38/AEDU/FSD/2019",
    "name": "Yandi Gunadi",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "39/AEDU/BA/2019",
    "name": "Mikhael",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "40/AEDU/GD/2019",
    "name": "Arga Revata Surya",
    "scheme": "Game Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "41/AEDU/FSD/2019",
    "name": "Fachreza Audrian Naufal",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "42/AEDU/FSD/2019",
    "name": "William Tibie",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "43/AEDU/FSD/2019",
    "name": "Wilson Nursalin",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "44/AEDU/FSD/2019",
    "name": "Winsen Wijaya ",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "45/AEDU/FSD/2019",
    "name": "Eric Sebastian",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "46/AEDU/BA/2019",
    "name": "Christiane Karen",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "47/AEDU/BA/2019",
    "name": "Felix Winangun",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "48/AEDU/BA/2019",
    "name": "Jelvin Taniawan",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "49/AEDU/SMSP/2019",
    "name": "Kenny Nataniel",
    "scheme": "Scrum Master Specialist",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Scrum Master Specialist"
  },
  {
    "number": "50/AEDU/FSD/2019",
    "name": "Nathaniel Christian Salim",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "51/AEDU/FSD/2019",
    "name": "Prillysia Anasthasia Michael",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "52/AEDU/FSD/2019",
    "name": "Raden Muhammad Ezra Ghaziafi",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "53/AEDU/FSD/2019",
    "name": "Roberto",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "54/AEDU/BA/2019",
    "name": "Steven",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "55/AEDU/FSD/2019",
    "name": "Dennis Harley",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "56/AEDU/FSD/2019",
    "name": "Devin Jastona Kumala",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "57/AEDU/ARC/2019",
    "name": "Evan Emelga",
    "scheme": "Architect",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Architect"
  },
  {
    "number": "58/AEDU/BA/2019",
    "name": "Hans Darmawan",
    "scheme": "Business Analyst",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "59/AEDU/FSD/2019",
    "name": "Hardyanti Citrawati",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "60/AEDU/FSD/2019",
    "name": "Kelvin Junilson",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "61/AEDU/FSD/2019",
    "name": "Tan, Samuel Arno Saputra",
    "scheme": "Full Stack Developer",
    "date": "2019",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "62/AEDU/ARC/2020",
    "name": "Calvin ",
    "scheme": "Architect",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Architect"
  },
  {
    "number": "63/AEDU/FSD/2020",
    "name": "Patrick Liviyanto",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "64/AEDU/BA/2020",
    "name": "Adrian Aziz Gunawan",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "65/AEDU/FSD/2020",
    "name": "Aldrian Kwantawijaya",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "66/AEDU/FSD/2020",
    "name": "Eagar Satya",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "67/AEDU/FSD/2020",
    "name": "Geraldy Oscar Reinard\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "68/AEDU/FSD/2020",
    "name": "David",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "69/AEDU/FSD/2020",
    "name": "Vernando Cahyadi",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "70/AEDU/FSD/2020",
    "name": "Michael Gunawan\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "71/AEDU/BA/2020",
    "name": "Christian Wijaya\u00a0",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "72/AEDU/BA/2020",
    "name": "Dicky Hanoardjo",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "73/AEDU/BA/2020",
    "name": "Sandi Pratama Pangalila",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "74/AEDU/BA/2020",
    "name": "Andreas Hoffman Parulian",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "75/AEDU/FSD/2020",
    "name": "Kenny",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "76/AEDU/FSD/2020",
    "name": "Michael Martin",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "77/AEDU/FSD/2020",
    "name": "Alberttius Winata Wijaya",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "78/AEDU/FSD/2020",
    "name": "Surya",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "79/AEDU/FSD/2020",
    "name": "Dhimas Bagus Rizky Dewanto\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "80/AEDU/FSD/2020",
    "name": "Steven Jonathan Hodiono\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "81/AEDU/FSD/2020",
    "name": "Erlina",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "82/AEDU/BA/2020",
    "name": "Jonathan Riady Suyanto\u00a0",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "83/AEDU/FSD/2020",
    "name": "Christian ",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "84/AEDU/FSD/2020",
    "name": "Christopher Nathan Then",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "85/AEDU/BA/2020",
    "name": "Felix Lauwrensius",
    "scheme": "Business Analyst",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "86/AEDU/FSD/2020",
    "name": "Teguh Wibowo Wijaya\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "87/AEDU/FSD/2020",
    "name": "Jeremy Levian Febry\u00a0",
    "scheme": "Full Stack Developer",
    "date": "2020",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "88/AEDU/FSD/2021",
    "name": "Aloisius Bagas Wicaksono",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "89/AEDU/FSD/2021",
    "name": "Bernardus Joshua Otto Prayoga",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "90/AEDU/BA/2021",
    "name": "Gerry Gideon Ticoalu",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "91/AEDU/FSD/2021",
    "name": "Ignatius Richard Sutiono",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "92/AEDU/FSD/2021",
    "name": "Jeffry",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "93/AEDU/FSD/2021",
    "name": "Leonardo",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "94/AEDU/BA/2021",
    "name": "Riccosan",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "95/AEDU/FSD/2021",
    "name": "Rizky Aditya Ramadhani",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "96/AEDU/FSD/2021",
    "name": "Steven Arta Lionggi",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "97/AEDU/FSD/2021",
    "name": "Vincent Hartanto Linti",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "98/AEDU/GD/2021",
    "name": "Yosua Maselyno",
    "scheme": "Game Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "99/AEDU/FSD/2021",
    "name": "Albert Cryssiover",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "100/AEDU/FSD/2021",
    "name": "Dannys Dian Rachmantyo",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "101/AEDU/SMHA/2021",
    "name": "Djohan Effendi",
    "scheme": "Social Media and Head Assistant",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media and Head Assistant"
  },
  {
    "number": "102/AEDU/FSD/2021",
    "name": "Domenico Primussendy Setiantoro",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "103/AEDU/VES/2021",
    "name": "Edric Aldo",
    "scheme": "Video Editor Specialist",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Editor Specialist"
  },
  {
    "number": "104/AEDU/HC/2021",
    "name": "Elisa Darnela Putriwikanti",
    "scheme": "Human Capital",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "105/AEDU/FSD/2021",
    "name": "Elsya At-Haya Tiffani",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "106/AEDU/BA/2021",
    "name": "Eugenius Hansel Lee",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "107/AEDU/BA/2021",
    "name": "Fernando Jose",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "108/AEDU/FSD/2021",
    "name": "Frendy Crystian",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "109/AEDU/SMS/2021",
    "name": "Ivan Wahyu Pamungkas",
    "scheme": "Social Media Specialist",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "110/AEDU/FSD/2021",
    "name": "Joel Oktavianus",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "111/AEDU/BA/2021",
    "name": "Johan Frederik Margono",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "112/AEDU/BA/2021",
    "name": "Jovan Andrean",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "113/AEDU/FSD/2021",
    "name": "Justine Rusli",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "114/AEDU/FSD/2021",
    "name": "Kahfi KN",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "115/AEDU/BA/2021",
    "name": "Kevin",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "116/AEDU/FSD/2021",
    "name": "Michael Riandy Setiawan",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "117/AEDU/FSD/2021",
    "name": "Mohamad Fernanda",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "118/AEDU/BA/2021",
    "name": "Mozan Hafiz Mahardhika",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "119/AEDU/BA/2021",
    "name": "Nickson",
    "scheme": "Business Analyst",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "120/AEDU/FSD/2021",
    "name": "Owen Marcelo",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "121/AEDU/VES/2021",
    "name": "Raditya Mirza Pranamya",
    "scheme": "Video Editor Specialist",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Editor Specialist"
  },
  {
    "number": "122/AEDU/FSD/2021",
    "name": "Rendy Noviyanto",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "123/AEDU/FSD/2021",
    "name": "Ricky Kurniawan",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "124/AEDU/SMS/2021",
    "name": "Sarah Ghina Nadhifa",
    "scheme": "Social Media Specialist ",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist "
  },
  {
    "number": "125/AEDU/VES/2021",
    "name": "Sasqi Anada Dhea",
    "scheme": "Video Editor Specialist",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Editor Specialist"
  },
  {
    "number": "126/AEDU/FSD/2021",
    "name": "Sutiono Ongthe Wijaya",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "127/AEDU/FSD/2021",
    "name": "Theofilus Marcellino",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "128/AEDU/FSD/2021",
    "name": "Vina Rahmi Riani",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "129/AEDU/FSD/2021",
    "name": "William",
    "scheme": "Full Stack Developer",
    "date": "2021",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "130/AEDU/BA/2022",
    "name": "Aldian Eka Tanudjaja",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "131/AEDU/BA/2022",
    "name": "Christopher Bryan Tantri",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "132/AEDU/BA/2022",
    "name": "Gavin Dominic Thenristian",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "133/AEDU/BA/2022",
    "name": "Jassen Harjianto Sunandar",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "134/AEDU/BA/2022",
    "name": "Kevin Nathaniel",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "135/AEDU/BA/2022",
    "name": "Michael Saverio Noventa",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "136/AEDU/BA/2022",
    "name": "Muhammad Mahdy Satria",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "137/AEDU/BA/2022",
    "name": "Rafi Giffari",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "138/AEDU/FSD/2022",
    "name": "Adrian Arcadius Vitalis",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "139/AEDU/FSD/2022",
    "name": "Akmal Wiraprana",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "140/AEDU/FSD/2022",
    "name": "Andi Prasetyo",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "141/AEDU/FSD/2022",
    "name": "Andrean Constantin",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "142/AEDU/BA/2022",
    "name": "Andrew Julisar",
    "scheme": "Business Analyst",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "143/AEDU/FSD/2022",
    "name": "Chaerul Rizky",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "144/AEDU/FSD/2022",
    "name": "Claudia Ananthio",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "145/AEDU/FSD/2022",
    "name": "Hamzah Ismail",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "146/AEDU/FSD/2022",
    "name": "Hutama Sakyananda",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "147/AEDU/FSD/2022",
    "name": "Kent Martin Tanujoyo",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "148/AEDU/FSD/2022",
    "name": "Mietha Anditta",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "149/AEDU/FSD/2022",
    "name": "Philip Kwandynata",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "150/AEDU/FSD/2022",
    "name": "Popo Fianto",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "151/AEDU/FSD/2022",
    "name": "Reyhan Widjaja",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "152/AEDU/FSD/2022",
    "name": "Richie",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "153/AEDU/FSD/2022",
    "name": "Ryo Kenrie Wongso",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "154/AEDU/FSD/2022",
    "name": "Samuel",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "155/AEDU/FSD/2022",
    "name": "Samuel Erdianto Simon",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "156/AEDU/FSD/2022",
    "name": "Tengku Nurel",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "157/AEDU/FSD/2022",
    "name": "Theresia Kharisma",
    "scheme": "Full Stack Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "158/AEDU/GD/2022",
    "name": "Devin Christoforus Suherman",
    "scheme": "Game Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "159/AEDU/GD/2022",
    "name": "Robbie",
    "scheme": "Game Developer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "160/AEDU/GRD/2022",
    "name": "Maevy Andriani Halim",
    "scheme": "Graphic Design",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Graphic Design"
  },
  {
    "number": "161/AEDU/HRS/2022",
    "name": "Farah Abelia Lazfi",
    "scheme": "Human Resource Specialist",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Resource Specialist"
  },
  {
    "number": "162/AEDU/UIUX/2022",
    "name": "Selly",
    "scheme": "UI/UX Designer",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "UI/UX Designer"
  },
  {
    "number": "163/AEDU/VMS/2022",
    "name": "Evan Zasli",
    "scheme": "Video Maker Specialist",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Maker Specialist"
  },
  {
    "number": "164/AEDU/VMS/2022",
    "name": "Nicholas Matthew Antoni",
    "scheme": "Video Maker Specialist",
    "date": "2022",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Maker Specialist"
  },
  {
    "number": "165/AEDU/VES/2023",
    "name": "Adrian Pangestu",
    "scheme": "Video Editor Specialist",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Editor Specialist"
  },
  {
    "number": "166/AEDU/HRS/2023",
    "name": "Aulya Hidda Mheynona",
    "scheme": "Human Resource Specialist",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Resource Specialist"
  },
  {
    "number": "167/AEDU/IOT/2023",
    "name": "Billie Christanto",
    "scheme": "IOT Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "IOT Developer"
  },
  {
    "number": "168/AEDU/GD/2023",
    "name": "Bonaventura Jason Sulaiman",
    "scheme": "Game Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "169/AEDU/IOT/2023",
    "name": "Daffa Rizki Rizaly",
    "scheme": "IOT Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "IOT Developer"
  },
  {
    "number": "170/AEDU/BA/2023",
    "name": "Dendi Yudha Pramudya",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "171/AEDU/BA/2023",
    "name": "Edwin Tunggoro",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "172/AEDU/FSD/2023",
    "name": "Endrico Lansky",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "173/AEDU/BA/2023",
    "name": "Enrico Theodore Vernatha",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "174/AEDU/HRS/2023",
    "name": "Erlangga Asyam Fauzian Suyani",
    "scheme": "Human Resource Specialist",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Resource Specialist"
  },
  {
    "number": "175/AEDU/FSD/2023",
    "name": "Evan Marvelian",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "176/AEDU/FSD/2023",
    "name": "Felix Fauzan",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "177/AEDU/FSD/2023",
    "name": "Ferdynand Wira Yudha",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "178/AEDU/FSD/2023",
    "name": "Fiona Varencia Tendio",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "179/AEDU/GRD/2023",
    "name": "Francisca Ardianti",
    "scheme": "Graphic Designer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Graphic Designer"
  },
  {
    "number": "180/AEDU/FSD/2023",
    "name": "Gabrielle Angelica Ivandi",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "181/AEDU/FSD/2023",
    "name": "Glenn Karjadidjaja",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "182/AEDU/FSD/2023",
    "name": "Hansen Rowen Charlie",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "183/AEDU/FSD/2023",
    "name": "Hizkia Duchari Putra",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "184/AEDU/FSD/2023",
    "name": "Husodo Wijaya",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "185/AEDU/FSD/2023",
    "name": "Indah Mursyida Bahrina",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "186/AEDU/GD/2023",
    "name": "Javin Rionardi",
    "scheme": "Game Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "187/AEDU/BA/2023",
    "name": "Jefferson Wibisono",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "188/AEDU/FSD/2023",
    "name": "Jeffry Kosasih",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "189/AEDU/BA/2023",
    "name": "Jeremy Ken",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "190/AEDU/SMC/2023",
    "name": "Jonathan Christian Tjandra",
    "scheme": "Social Media Copywriter",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Copywriter"
  },
  {
    "number": "191/AEDU/BA/2023",
    "name": "Kevin Daniel Tampubulon",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "192/AEDU/FSD/2023",
    "name": "Kevin Orlando",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "193/AEDU/BA/2023",
    "name": "Khalfani Alvand",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "194/AEDU/FSD/2023",
    "name": "Lyvia Cornelia Michael",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "195/AEDU/FSD/2023",
    "name": "Michael Thamniago",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "196/AEDU/FSD/2023",
    "name": "Mikhael Kirenius Ranata",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "197/AEDU/FSD/2023",
    "name": "Mileno Valdo Elvano",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "198/AEDU/GRD/2023",
    "name": "Nathania Gunawan",
    "scheme": "Graphic Designer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Graphic Designer"
  },
  {
    "number": "199/AEDU/FSD/2023",
    "name": "Nelsen Ardian",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "200/AEDU/FSD/2023",
    "name": "Nicholas William Andrianto",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "201/AEDU/BA/2023",
    "name": "Philipus Cahyadi",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "202/AEDU/AM/2023",
    "name": "Pranita Elsa Safitri Nugraheni",
    "scheme": "Admin Marketing",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Admin Marketing"
  },
  {
    "number": "203/AEDU/FSD/2023",
    "name": "Raden Haryo Rangga Wijaya",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "204/AEDU/FSD/2023",
    "name": "Rahadi Fauzan Ramadhan",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "205/AEDU/FSD/2023",
    "name": "Revin Hermawan Rusli",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "206/AEDU/VES/2023",
    "name": "Richard Yohanes Tanuwijaya",
    "scheme": "Video Editor Specialist",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Video Editor Specialist"
  },
  {
    "number": "207/AEDU/FSD/2023",
    "name": "Risky Hidayat",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "208/AEDU/FSD/2023",
    "name": "Ryan Frederick Muliawan",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "209/AEDU/BA/2023",
    "name": "Shilvi",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "210/AEDU/BA/2023",
    "name": "Sinclair Claus Chang",
    "scheme": "Business Analyst",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "211/AEDU/FSD/2023",
    "name": "Yobel Sahala Sitorus",
    "scheme": "Full Stack Developer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "212/AEDU/ERP/2023",
    "name": "Jonathan Christopher",
    "scheme": "ERP Consultant",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "ERP Consultant"
  },
  {
    "number": "213/AEDU/ERP/2023",
    "name": "Vidiyansyah Rizky Novaldi",
    "scheme": "ERP Consultant",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "ERP Consultant"
  },
  {
    "number": "214/AEDU/ERP/2023",
    "name": "Malko Hidamukti",
    "scheme": "ERP Consultant",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "ERP Consultant"
  },
  {
    "number": "215/AEDU/DE/2023",
    "name": "Dennis Malinton",
    "scheme": "Data Engineer",
    "date": "2023",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Data Engineer"
  },
  {
    "number": "216/AEDU/BA/2024",
    "name": "Abdan Maulana Halim",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "217/AEDU/BA/2024",
    "name": "Gybrnd Tasawuf",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "218/AEDU/BA/2024",
    "name": "Hendy Wijaya",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "219/AEDU/BA/2024",
    "name": "Jaya Hikmat",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "220/AEDU/BA/2024",
    "name": "Liem Enrico Christiano Hartono",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "221/AEDU/BA/2024",
    "name": "Marctovin",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "222/AEDU/BA/2024",
    "name": "Marvello Stefanus",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "223/AEDU/BA/2024",
    "name": "Michelle Angelita",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "224/AEDU/BA/2024",
    "name": "Riechie Cang",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "225/AEDU/BA/2024",
    "name": "Winston Susanto",
    "scheme": "Business Analyst",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "226/AEDU/BD/2024",
    "name": "Apriani Agusthina Duka",
    "scheme": "Business Development",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "227/AEDU/BD/2024",
    "name": "Galfin Anderias Adu",
    "scheme": "Business Development",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "228/AEDU/BD/2024",
    "name": "Tirza Novita Adelin Bessie",
    "scheme": "Business Development",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "229/AEDU/BD/2024",
    "name": "Adelberta Vedruna Tae",
    "scheme": "Business Development",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "230/AEDU/BD/2024",
    "name": "Andreas",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "231/AEDU/FSD/2024",
    "name": "Ardyanto Konstantin",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "232/AEDU/FSD/2024",
    "name": "Cris Limpar",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "233/AEDU/FSD/2024",
    "name": "Davin Valentino",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "234/AEDU/FSD/2024",
    "name": "Jason Sasmita",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "235/AEDU/FSD/2024",
    "name": "Jeta Nanda Manggala Halim",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "236/AEDU/FSD/2024",
    "name": "Jonathan Sachio",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "237/AEDU/FSD/2024",
    "name": "Jovan Steven",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "238/AEDU/FSD/2024",
    "name": "Kenny",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "239/AEDU/FSD/2024",
    "name": "Michelle Angela Guntjoro",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "240/AEDU/FSD/2024",
    "name": "Neil Alexander",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "241/AEDU/FSD/2024",
    "name": "Putu Chintya Puja Ningtyas",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "242/AEDU/FSD/2024",
    "name": "Reisyan Nathan Kusuma",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "243/AEDU/FSD/2024",
    "name": "Vanness Iwata",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "244/AEDU/FSD/2024",
    "name": "Vasthy Rezki Tanisya",
    "scheme": "Full Stack Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Full Stack Developer"
  },
  {
    "number": "245/AEDU/GD/2024",
    "name": "Timothy Kenji",
    "scheme": "Game Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "246/AEDU/GD/2024",
    "name": "William",
    "scheme": "Game Developer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Game Developer"
  },
  {
    "number": "247/AEDU/HRS/2024",
    "name": "Wenni",
    "scheme": "Human Resource Specialist",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Resource Specialist"
  },
  {
    "number": "248/AEDU/MSS/2024",
    "name": "Nadya Harsari",
    "scheme": "Marketing Support Specialist",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Marketing Support Specialist"
  },
  {
    "number": "249/AEDU/SMS/2024",
    "name": "Feny",
    "scheme": "Social Media Specialist",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "250/AEDU/SMS/2024",
    "name": "Firda Ratnasari",
    "scheme": "Social Media Specialist",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "251/AEDU/SMS/2024",
    "name": "Syakirah Badilah",
    "scheme": "Social Media Specialist",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "252/AEDU/UIUX/2024",
    "name": "Elang Satria Pamungkas",
    "scheme": "UI/UX Designer",
    "date": "2024",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "UI/UX Designer"
  },
  {
    "number": "253/AEDU/JSE/2025",
    "name": "Aldi Putra",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "254/AEDU/BA/2025",
    "name": "Alettadhira Syasyah",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "255/AEDU/JSE/2025",
    "name": "Alvaro Bernardyn Chea",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "256/AEDU/JSE/2025",
    "name": "Ammar Yaafi Adhinegoro",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "257/AEDU/JSE/2025",
    "name": "Andrew Krisna Ferdinanto",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "258/AEDU/BA/2025",
    "name": "Avril Angelin",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "259/AEDU/JSE/2025",
    "name": "Axel Valent",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "260/AEDU/JSE/2025",
    "name": "Christian Antonius",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "261/AEDU/BA/2025",
    "name": "Christian Theddy",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "262/AEDU/JSE/2025",
    "name": "Christopher Benjamin Junjungan Halomoan Panggabean",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "263/AEDU/JSE/2025",
    "name": "Christophorus Augusta Wangsa",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "264/AEDU/BA/2025",
    "name": "Daniel Rhivalldo",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "265/AEDU/BA/2025",
    "name": "Dhea Annisa Permata Hati",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "266/AEDU/JSE/2025",
    "name": "Eryn Angela",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "267/AEDU/JSE/2025",
    "name": "Eyzar Hermanio",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "268/AEDU/JSE/2025",
    "name": "Geraldo Nathanael",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "269/AEDU/JSE/2025",
    "name": "Hisyam Abdul Malik",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "270/AEDU/JSE/2025",
    "name": "Ignatius Adrian Wibowo",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "271/AEDU/CS/2025",
    "name": "Ikbar Muhammad Mumtaz",
    "scheme": "Cyber Security Specialist",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Cyber Security Specialist"
  },
  {
    "number": "272/AEDU/JSE/2025",
    "name": "Jeffrey William",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "273/AEDU/JSE/2025",
    "name": "Jemy Nathanael",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "274/AEDU/BA/2025",
    "name": "Jonathan Lie",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "275/AEDU/BA/2025",
    "name": "Kevin Leander Sukmana",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "276/AEDU/JSE/2025",
    "name": "Leonardus Evan Kasena",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "277/AEDU/MSS/2025",
    "name": "Livia Delicia Gian Tjam",
    "scheme": "Marketing Support Specialist",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Marketing Support Specialist"
  },
  {
    "number": "278/AEDU/HRS/2025",
    "name": "Melly",
    "scheme": "Human Resource Specialist",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Resource Specialist"
  },
  {
    "number": "279/AEDU/BA/2025",
    "name": "Nabhan Yahya Anuz",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "280/AEDU/JSE/2025",
    "name": "Narendra Aldo Satya Dharma",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "281/AEDU/JSE/2025",
    "name": "Nicholas Christopher",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "282/AEDU/JSE/2025",
    "name": "Nicholas Hans Muliawan",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "283/AEDU/JSE/2025",
    "name": "Owen Bernhard",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "284/AEDU/BA/2025",
    "name": "Owen Felipe Gunawan",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "285/AEDU/BA/2025",
    "name": "Ricky Pratama Liang",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "286/AEDU/BA/2025",
    "name": "Ricky Sunarko",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "287/AEDU/BA/2025",
    "name": "Rivaldo Tanbung",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "288/AEDU/JSE/2025",
    "name": "Robertus Ferdinand",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "289/AEDU/JSE/2025",
    "name": "Ruben Sugianto",
    "scheme": "Junior Software Engineer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "290/AEDU/UIUX/2025",
    "name": "Satya Maitreyawira",
    "scheme": "UI/UX Designer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "UI/UX Designer"
  },
  {
    "number": "291/AEDU/BA/2025",
    "name": "Stephen Ardy",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "292/AEDU/BA/2025",
    "name": "Steven Suryadi",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "293/AEDU/DPO/2025",
    "name": "Tegar Tri Cahyo",
    "scheme": "Data Protection Officer",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Data Protection Officer"
  },
  {
    "number": "294/AEDU/BA/2025",
    "name": "Vaness",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "295/AEDU/BA/2025",
    "name": "Verent Febrian",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "296/AEDU/BA/2025",
    "name": "Wahyu Dwi Setio Wibowo",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "297/AEDU/BA/2025",
    "name": "Wesley Wilnio",
    "scheme": "Business Analyst",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "298/AEDU/SMS/2025",
    "name": "Yehezkia Sukma Nathania",
    "scheme": "Social Media Specialist",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "299/AEDU/SMS/2025",
    "name": "Yuvianto Salim",
    "scheme": "Social Media Specialist",
    "date": "2025",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "300/AEDU/JSE/2026",
    "name": "Bryan Jonatan",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "301/AEDU/JSE/2026",
    "name": "Candra Wijaya",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "302/AEDU/JSE/2026",
    "name": "Christine Irene Silalahi",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "303/AEDU/JSE/2026",
    "name": "Darwin Donovan Darmadi",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "304/AEDU/JSE/2026",
    "name": "Elvan Nicola",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "305/AEDU/JSE/2026",
    "name": "Hansel Wilam",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "306/AEDU/JSE/2026",
    "name": "I Kadek Prasetya Adhi Nugraha",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "307/AEDU/JSE/2026",
    "name": "Jessen",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "308/AEDU/JSE/2026",
    "name": "Juan Thoriq Pahlevi",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "309/AEDU/JSE/2026",
    "name": "Kezia Angeline Santoso",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "310/AEDU/JSE/2026",
    "name": "Liem Steven Christiano Hartono",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "311/AEDU/JSE/2026",
    "name": "Lorensius Bernard Gani",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "312/AEDU/JSE/2026",
    "name": "Muhammad Zaki Revandi",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "313/AEDU/JSE/2026",
    "name": "Nathan Widjaja",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "314/AEDU/JSE/2026",
    "name": "Vincent Kurnia",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "315/AEDU/JSE/2026",
    "name": "Nelsen Timoty",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "316/AEDU/JSE/2026",
    "name": "Evander Nikolai",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "317/AEDU/JSE/2026",
    "name": "Benedict Wijaya",
    "scheme": "Junior Software Engineer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Junior Software Engineer"
  },
  {
    "number": "318/AEDU/BA/2026",
    "name": "Jones Alvin ",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "319/AEDU/BA/2026",
    "name": "Jonathan Sindunata",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "320/AEDU/BA/2026",
    "name": "Muhammad Zianurahman",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "321/AEDU/BA/2026",
    "name": "Muhammad Raynathan Priady Sofyan",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "322/AEDU/BA/2026",
    "name": "Laurentius Justin",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "323/AEDU/BA/2026",
    "name": "Indra Cetta Daniswara",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "324/AEDU/BA/2026",
    "name": "Steven Albert",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "325/AEDU/BA/2026",
    "name": "Ron Norbert Wijaya",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "326/AEDU/BA/2026",
    "name": "Nicholas Fransiscus Huang",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "327/AEDU/BA/2026",
    "name": "Muhammad Hauzan Ariq",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "328/AEDU/BA/2026",
    "name": "Cindy Amelia Saputra",
    "scheme": "Business Analyst",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Analyst"
  },
  {
    "number": "329/AEDU/MA/2026",
    "name": "Stanley",
    "scheme": "Marketing Admin",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Marketing Admin"
  },
  {
    "number": "330/AEDU/CSC/2026",
    "name": "Griventh Griffith Agustin",
    "scheme": "Cyber Security Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Cyber Security Specialist"
  },
  {
    "number": "331/AEDU/ACC/2026",
    "name": "Matthew Reyhan Dyson",
    "scheme": "Accounting",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Accounting"
  },
  {
    "number": "332/AEDU/ACC/2026",
    "name": "Berlian Selvia",
    "scheme": "Accounting",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Accounting"
  },
  {
    "number": "333/AEDU/SMS/2026",
    "name": "Cindy Cynara",
    "scheme": "Social Media Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "334/AEDU/SMS/2026",
    "name": "Bernike Elhista Tarigan",
    "scheme": "Social Media Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Social Media Specialist"
  },
  {
    "number": "335/AEDU/UIUX/2026",
    "name": "Eka Ray Putra Panjaitan",
    "scheme": "UI/UX Designer",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "UI/UX Designer"
  },
  {
    "number": "336/AEDU/HC/2026",
    "name": "Hongky Ricardo",
    "scheme": "Human Capital",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "337/AEDU/HC/2026",
    "name": "Zahra Fatinaturridha",
    "scheme": "Human Capital",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "338/AEDU/HC/2026",
    "name": "Mutia Azzahra",
    "scheme": "Human Capital",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "339/AEDU/HC/2026",
    "name": "Khalisa Safa Aliya",
    "scheme": "Human Capital",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "340/AEDU/HC/2026",
    "name": "Talitha Syahla Aqillah",
    "scheme": "Human Capital",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Human Capital"
  },
  {
    "number": "341/AEDU/PAM/2026",
    "name": "Kevin Nathanael Tjondrodiputro",
    "scheme": "Procurement Asset Management Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Procurement Asset Management Specialist"
  },
  {
    "number": "342/AEDU/CES/2026",
    "name": "Glen Brian William",
    "scheme": "Content Editor Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Content Editor Specialist"
  },
  {
    "number": "343/AEDU/PA/2026",
    "name": "Rina Pahrija",
    "scheme": "Project Admin",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Project Admin"
  },
  {
    "number": "344/AEDU/BD/2026",
    "name": "Okky Ananda",
    "scheme": "Business Development",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "345/AEDU/BD/2026",
    "name": "Julio Thirty",
    "scheme": "Business Development",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "346/AEDU/BD/2026",
    "name": "Nur Intan",
    "scheme": "Business Development",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "347/AEDU/BD/2026",
    "name": "Dwi Oktaviani",
    "scheme": "Business Development",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "348/AEDU/BD/2026",
    "name": "Ika Budi",
    "scheme": "Business Development",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Business Development"
  },
  {
    "number": "349/AEDU/CPM/2026",
    "name": "Dilara Kynta",
    "scheme": "Co-Project Manager",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Co-Project Manager"
  },
  {
    "number": "350/AEDU/CES/2026",
    "name": "Fajar Ibnugroho",
    "scheme": "Content Editor Specialist",
    "date": "2026",
    "status": "Aktif",
    "type": "Bootcamp",
    "category": "Content Editor Specialist"
  }
];


// {
//   number: "DG-0001",
//   name: "Maria Tan",
//   scheme: "Desainer Grafis",
//   date: "2025-05-12",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Desainer Grafis",
// },
// {
//   number: "DG-0002",
//   name: "Alex Pratama",
//   scheme: "Desainer Grafis",
//   date: "2025-04-18",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Desainer Grafis",
// },
// {
//   number: "DG-0003",
//   name: "Lina Kusuma",
//   scheme: "Desainer Grafis",
//   date: "2024-12-02",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "Desainer Grafis",
// },
// {
//   number: "DG-0004",
//   name: "Teguh Haryanto",
//   scheme: "Desainer Grafis",
//   date: "2025-02-20",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Desainer Grafis",
// },
// {
//   number: "DG-0005",
//   name: "Nadia Puspita",
//   scheme: "Desainer Grafis",
//   date: "2025-07-05",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Desainer Grafis",
// },

// {
//   number: "WA-0001",
//   name: "Andi Wijaya",
//   scheme: "Web Analyst",
//   date: "2024-11-01",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "Web Analyst",
// },
// {
//   number: "WA-0002",
//   name: "Rizky Hidayat",
//   scheme: "Web Analyst",
//   date: "2025-03-10",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Web Analyst",
// },
// {
//   number: "WA-0003",
//   name: "Sinta Dewi",
//   scheme: "Web Analyst",
//   date: "2025-06-14",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Web Analyst",
// },
// {
//   number: "WA-0004",
//   name: "Budi Santoso",
//   scheme: "Web Analyst",
//   date: "2025-07-22",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Web Analyst",
// },
// {
//   number: "WA-0005",
//   name: "Clara Wijaya",
//   scheme: "Web Analyst",
//   date: "2025-01-09",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "Web Analyst",
// },

// {
//   number: "PW-0001",
//   name: "Lorensius Bernard Gani",
//   scheme: "Pengembang Web",
//   date: "2025-06-10",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Pengembang Web",
// },
// {
//   number: "PW-0002",
//   name: "Jessica Mulyani",
//   scheme: "Pengembang Web",
//   date: "2025-02-18",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Pengembang Web",
// },
// {
//   number: "PW-0003",
//   name: "Rafi Hakim",
//   scheme: "Pengembang Web",
//   date: "2024-10-05",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "Pengembang Web",
// },
// {
//   number: "PW-0004",
//   name: "William Gunawan",
//   scheme: "Pengembang Web",
//   date: "2025-04-21",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Pengembang Web",
// },
// {
//   number: "PW-0005",
//   name: "Selina Chen",
//   scheme: "Pengembang Web",
//   date: "2025-05-27",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Pengembang Web",
// },

// {
//   number: "BJ-0001",
//   name: "Akira Sato",
//   scheme: "Bahasa Jepang N4",
//   date: "2024-09-10",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Bahasa Jepang",
// },
// {
//   number: "BJ-0002",
//   name: "Hiroko Tanaka",
//   scheme: "Bahasa Jepang N3",
//   date: "2024-08-22",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Bahasa Jepang",
// },
// {
//   number: "BJ-0003",
//   name: "Rina Setiawan",
//   scheme: "Bahasa Jepang N4",
//   date: "2025-03-14",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Bahasa Jepang",
// },
// {
//   number: "BJ-0004",
//   name: "Kenji Nakamura",
//   scheme: "Bahasa Jepang N5",
//   date: "2024-11-29",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "Bahasa Jepang",
// },
// {
//   number: "BJ-0005",
//   name: "Sakura Ito",
//   scheme: "Bahasa Jepang N3",
//   date: "2025-02-05",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "Bahasa Jepang",
// },

// {
//   number: "IT-0001",
//   name: "Rina Setiawan",
//   scheme: "IT Bootcamp Fullstack",
//   date: "2024-08-15",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "IT",
// },
// {
//   number: "IT-0002",
//   name: "Kevin Lim",
//   scheme: "IT Bootcamp Fullstack",
//   date: "2024-12-10",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "IT",
// },
// {
//   number: "IT-0003",
//   name: "Dewi Anggraini",
//   scheme: "IT Bootcamp Fullstack",
//   date: "2025-01-20",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "IT",
// },
// {
//   number: "IT-0004",
//   name: "Michael Chen",
//   scheme: "IT Bootcamp Fullstack",
//   date: "2025-03-09",
//   status: "Aktif",
//   type: "Bootcamp",
//   category: "IT",
// },
// {
//   number: "IT-0005",
//   name: "Tasya Wijaya",
//   scheme: "IT Bootcamp Fullstack",
//   date: "2025-05-25",
//   status: "Nonaktif",
//   type: "Bootcamp",
//   category: "IT",
// },
